const settings = {
  lazyload: true,
  nav: false,
  mouseDrag: true,
  loop: true,
  items: 1,
  gutter: 10,
  autoplay: true,
  autoplayButtonOutput: false,
  container: "#responsive",
  responsive: {
    "600": {
      items: 2,
    }
  },
  controls: false
};

export { settings };
